import { render } from "./listForSchoolDetail.vue?vue&type=template&id=0141bf01&ts=true"
import script from "./listForSchoolDetail.vue?vue&type=script&lang=ts"
export * from "./listForSchoolDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__